<!--

-->

<template>
  <div class="boxHeader">

    <div class="boxHeader__headline">
      <h4>
        <span v-if="this.$props.headline">
          {{this.$props.headline}}
        </span>
        <span v-if="this.$props.counterNumber">
          <counter
            v-bind:countTo=this.$props.counterNumber>
          </counter>{{this.$props.counterUnit}}
        </span>
      </h4>
    </div>
    <h3 class="boxHeader__text">{{this.$props.text}}</h3>
  </div>
</template>


<script>
import counter from './counter.vue';

export default {
  name: 'boxHeader',
  components: {
    counter,
  },
  props: ['headline', 'text', 'counterNumber', 'counterUnit'],
  data() {
    return {
    };
  },
};
</script>


<style lang="scss" scoped>
  .boxHeader {
    position: relative;
    background: linear-gradient(45deg, rgba(20,90,127,1) 0%, rgba(20,90,127,1) 0%, rgba(67,172,223,1) 100%);
    text-align: center;
    z-index: 1;
    opacity: 0;
    transform: scaleX(0);
    transition: all 0.5s ease-in-out;

    @media #{$mobile} {
      padding: 1.5rem var(--boxPadding);
    }
    @media #{$min-tablet} {
      padding: 1.5rem var(--boxPaddingDesk);
    }
  }
  .box.mounted .boxHeader {
    opacity: 1;
    transform: scaleX(1);
  }
  .boxHeader__headline {
    color: var(--white);
    opacity: 0.4;

    @media #{$min-tablet} {
      margin-bottom: 0.75rem;
    }
  }
  .boxHeader__text {
    color: var(--white);
  }
</style>
